/**
 * Copyright (c) 2020
 *
 * @summary calls to dataReport/advertising API
 * @author Julien <julien.donnadieu@yooda.com>
 *
 * Created at     : 2020-11-17 10:21:56
 * Last modified  : 2020-11-17 15:31:17
 */

import axios from '@/api/axios.js'

export default {

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readAdwordsAdvertisers (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/advertising/adwords-advertisers`,filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readAdwordsCompetitionKeywords (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/advertising/adwords-competition-keywords`,filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readAdwordsPerformance (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/advertising/adwords-performance`, filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readAdwordsTopCompetitor (projectId,filters=null) {
        return axios.get(`/report/data/projects/${projectId}/advertising/adwords-top-competitor`,filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readConversion (projectId,filters=null) {
        return axios.get(`/report/data/projects/${projectId}/advertising/conversion`,filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readIncomingTraffic (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/advertising/incoming-traffic`,filters)
    },


    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readShoppingAdvertisers (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/advertising/shopping-advertisers`,filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readShoppingCompetitionKeywords (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/advertising/shopping-competition-keywords`,filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readShoppingPerformance (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/advertising/shopping-performance`,filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readShoppingTopCompetitor (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/advertising/shopping-top-competitor`, filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readTurnover (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/advertising/turnover`,filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readAdvertisingAdwordsAdvertiserKeywords (projectId, filters=null) {

        return axios.get(`/report/data/projects/${projectId}/advertising/adwords-advertiser-keywords`,filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readAdvertisingAdwordsAdvertiserAds (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/advertising/adwords-advertiser-ads`,filters)
    },

    /**
     * @param projectId int
     * @param keywordId int
     * @param filters
     * @returns Promise
     */
    readAdwordsKeywordsAds (projectId,keywordId,filters=null) {
        return axios.get(`/report/data/projects/${projectId}/advertising/adwords-keywords-ads/keywords/${keywordId}`, filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readShoppingAdvertiserKeywords (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/advertising/shopping-advertiser-keywords`,filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readShoppingAdvertiserAds (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/advertising/shopping-advertiser-ads`, filters)
    },

    /**
     * @param projectId int
     * @param keywordId int
     * @param filters
     * @returns Promise
     */
    readShoppingKeywordsAds (projectId,keywordId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/advertising/shopping-keywords-ads/keywords/${keywordId}`, filters)
    },

};
